<template>
    <div class="p-1">
        <div>
            <render-editor-js :content="content.areas[0].content" v-if="content.areas[0].content" :component="{}"/>
        </div>
        <div class="video-frame">
            <video-player
                ref="videoPlayer"
                :options="playerOptions"
                @play="onPlay"
                @pause="onStop"
                @ended="onStop"
            />
        </div>
        <div>
            <render-editor-js :content="content.areas[1].content" v-if="content.areas[1].content" :component="{}"/>
        </div>
    </div>
</template>

<script>
    import {client as http} from "@/http_client";

    import 'video.js/dist/video-js.css'
    import { videoPlayer } from 'vue-video-player'
    import RenderEditorJs from "./RenderEditorJs";


    export default {
        components: {videoPlayer, RenderEditorJs},
        props: ['content'],
        data: function() {
            return {
                playing: false,
                playerOptions: {
                    // videojs options
                    muted: false,
                    fluid: true,
                    language: 'en',
                    poster: this.content.video.poster,

                    sources: [{
                        type: this.content.video.mime_type,
                        src: this.content.video.url
                    }],
                }
            }
        },
        methods: {
            save(area, data) {
                // this.data.areas[area].content = data;
            },
            // Mark this video as playing so the lesson timer keeps running while it
            // plays (watching is study time) and the idle auto-timeout is suppressed.
            onPlay() {
                if (!this.playing) {
                    this.playing = true;
                    this.$store.commit('VIDEO_PLAY');
                }
            },
            onStop() {
                if (this.playing) {
                    this.playing = false;
                    this.$store.commit('VIDEO_STOP');
                }
            }
        },
        beforeDestroy() {
            // Don't leave the count elevated if we navigate away mid-playback
            this.onStop();
        }
    };
</script>

<style lang="scss">
    .video-frame {
        border-radius: 5px;
        margin: 1rem 15% 1rem 1.3rem;
        border: 1px solid #e7e7e7;
        padding: 10px;
    }

    .video-player {
    }

    .library {
        position: fixed;
        top: 10px;
        right: 10px;
        bottom: 10px;
        left: 10px;

        background: white;
        z-index: 2001;
    }
</style>
